module.exports = __webpack_public_path__ + "static/img/HEDERA-blatt.9d810cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HEDERA-blatt.png
// module id = CB+a
// module chunks = 1